<template>
  <div class="hzc-discuss">
    <div class="mask" @click="closeIndustrial"></div>
    <div class="content">
      <p class="banner-title">{{ chainTitle }}</p>
      <div class="data1"><span style="color: #2AD3DA">{{ data1['price'] }}</span></div>
      <div class="data2"><span style="color: #2AD3DA">{{ data2['price'] }}</span></div>
      <div class="data3"><span style="color: #2AD3DA">{{ data3['price'] }}</span></div>
      <div class="data4"><span style="color: #2AD3DA">{{ data4['price'] }}</span>
      </div>
      <div class="data5"><span style="color: #2AD3DA">{{ data5['price'] }}</span>
      </div>
      <div class="data6"><span style="color: #2AD3DA">{{ data6['price'] }}</span>
      </div>
      <div class="data7"><span style="color: #2AD3DA">{{ data7['price'] }}</span>
      </div>
      <div class="data8"><span style="color: #2AD3DA">{{ data8['price'] }}</span>
      </div>
      <div class="differPrice1 redColor" v-if="chainPrice['differPrice1'] > 0">
        {{ '+' + chainPrice['differPrice1'] }}
      </div>
      <div class="differPrice1 greenColor" v-if="chainPrice['differPrice1'] < 0">{{ chainPrice['differPrice1'] }}
      </div>
      <div class="differPrice1" v-if="chainPrice['differPrice1'] === 0">—</div>
      <div class="differPrice2 redColor" v-if="chainPrice['differPrice2'] > 0">
        {{ '+' + chainPrice['differPrice2'] }}
      </div>
      <div class="differPrice2 greenColor" v-if="chainPrice['differPrice2'] < 0">{{ chainPrice['differPrice2'] }}
      </div>
      <div class="differPrice2" v-if="chainPrice['differPrice2'] === 0">—</div>
      <div class="differPrice3 redColor" v-if="chainPrice['differPrice3'] > 0">
        {{ '+' + chainPrice['differPrice3'] }}
      </div>
      <div class="differPrice3 greenColor" v-if="chainPrice['differPrice3'] < 0">{{ chainPrice['differPrice3'] }}
      </div>
      <div class="differPrice3" v-if="chainPrice['differPrice3'] === 0">—</div>
      <div class="differPrice4 redColor" v-if="chainPrice['differPrice4'] > 0">
        {{ '+' + chainPrice['differPrice4'] }}
      </div>
      <div class="differPrice4 greenColor" v-if="chainPrice['differPrice4'] < 0">{{ chainPrice['differPrice4'] }}
      </div>
      <div class="differPrice4" v-if="chainPrice['differPrice4'] === 0">—</div>
    </div>
  </div>
</template>

<script>

export default {
  props: [
    'chainTitle',
    'data1',
    'data2',
    'data3',
    'data4',
    'data5',
    'data6',
    'data7',
    'data8',
    'chainPrice'
  ],
  data() {
    return {}
  },
  created() {
  },
  beforeCreate() {
    document.querySelector('body').setAttribute('style', 'overflow:hidden')
  },
  beforeDestroy() {
    document.querySelector('body').removeAttribute('style')
  },
  methods: {
    /**
     * 关闭
     */
    closeIndustrial(val) {
      this.$emit('closeIndustrialCh', val);
    },
  }
}
</script>

<style lang="less" scoped>
.hzc-discuss {
  z-index: 101;
  width: 980px;
  height: 544px;
  background-color: #fff;

  .confirm {
    position: fixed;
    right: 10px;
    top: 10px;
    z-index: 110;
    width: 50px;
    cursor: pointer;
  }

  .mask {
    z-index: 100;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
  }

  .content {
    width: 980px;
    height: 546px;
    display: inline-block;
    background: url("../../assets/home/benyixichanyelian.png");
    background-size: 100% 100%;
    color: #fff;
    z-index: 101;
    position: relative;

    img {
      width: 980px;
      height: 544px;
    }

    .banner-title {
      position: absolute;
      color: #CEEFF6;
      top: 30px;
      left: 415px;
      font-size: 22px;
    }

    .data1 {
      width: 133px;
      height: 37px;
      font-size: 22px;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 37px;
      position: absolute;
      top: 250px;
      left: 30px;
      text-align: center;
    }

    .data2 {
      width: 133px;
      height: 37px;
      font-size: 22px;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 37px;
      position: absolute;
      top: 236px;
      left: 178px;
      text-align: center;
    }

    .data3 {
      font-size: 22px;
      width: 133px;
      position: absolute;
      top: 236px;
      left: 328px;
      text-align: center;
      height: 50px;
    }

    .data4 {
      width: 133px;
      font-size: 22px;
      position: absolute;
      top: 440px;
      left: 327px;
      text-align: center;
      height: 50px;
    }

    .data5 {
      font-size: 22px;
      position: absolute;
      top: 338px;
      left: 555px;
      width: 133px;
      height: 50px;
      text-align: center;
    }

    .data6 {
      font-size: 22px;
      position: absolute;
      top: 191px;
      left: 807px;
      width: 133px;
      height: 50px;
      text-align: center;
    }

    .data7 {
      font-size: 22px;
      position: absolute;
      top: 295px;
      left: 807px;
      width: 133px;
      height: 50px;
      text-align: center;
    }
    .data8 {
      font-size: 22px;
      position: absolute;
      top: 390px;
      left: 807px;
      width: 133px;
      height: 50px;
      text-align: center;
    }
    .differPrice1 {
      font-size: 22px;
      position: absolute;
      top: 375px;
      left: 442px;
      width: 100px;
      height: 25px;
      text-align: center;
    }

    .differPrice2 {
      font-size: 22px;
      position: absolute;
      top: 147px;
      left: 710px;
      width: 100px;
      height: 25px;
      text-align: center;
    }

    .differPrice3 {
      font-size: 22px;
      position: absolute;
      top: 254px;
      left: 710px;
      width: 100px;
      height: 25px;
      text-align: center;
    }

    .differPrice4 {
      font-size: 22px;
      position: absolute;
      top: 359px;
      left: 710px;
      width: 100px;
      height: 25px;
      text-align: center;
    }
  }

  .redColor {
    color: #FF6969;
  }

  .greenColor {
    color: #43E97B;
  }
}
</style>
